"use strict";
/**
 *
 */
var CompositeDisposable_1 = require('./CompositeDisposable');
var DisposableBase = (function () {
    function DisposableBase() {
        this._disposable = new CompositeDisposable_1.CompositeDisposable();
    }
    DisposableBase.prototype.dispose = function () {
        this._disposable.dispose();
    };
    return DisposableBase;
}());
exports.DisposableBase = DisposableBase;
//# sourceMappingURL=DisposableBase.js.map